import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { STAGE_LABELS } from "../lib/constants";
import { ChevronRight } from "lucide-react";

const GROUPS = [
  ["in_essere", "In essere", "#FDD003"],
  ["consegnato", "Preventivo consegnato / Contratto", "#10b981"],
  ["panchina", "In panchina", "#a855f7"],
  ["archiviato", "Archiviati / persi", "#9ca3af"],
];
const ACTIVE = ["in_essere", "consegnato"];
const eur = (v) => (v ? Number(v).toLocaleString("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }) : null);

// Popup "Technical Sales (Liv. 3)": progetti per stato, filtrabili, con apertura del lead.
export default function TechSalesDialog({ open, onOpenChange, items = [] }) {
  const [tab, setTab] = useState("active");
  const navigate = useNavigate();
  const active = items.filter((i) => ACTIVE.includes(i.status));
  const shown = tab === "active" ? active : items.filter((i) => i.status === tab);
  const lbl = Object.fromEntries(GROUPS.map(([k, l, c]) => [k, { l, c }]));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="tech-sales-dialog">
        <DialogHeader>
          <DialogTitle>Technical Sales (Liv. 3): {active.length} progetti</DialogTitle>
          <DialogDescription>Stessi criteri della pagina Progetti: progetti attivi (in essere + preventivo consegnato/contratto). Panchina e archiviati a parte.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-1.5">
          {[["active", "Attivi", "#e5e7eb"], ...GROUPS].map(([k, l, c]) => {
            const n = k === "active" ? active.length : items.filter((i) => i.status === k).length;
            return (
              <button key={k} type="button" onClick={() => setTab(k)} data-testid={`ts-tab-${k}`}
                className={`text-xs rounded-full border px-3 py-1 transition-colors ${tab === k ? "bg-primary text-primary-foreground border-primary" : "border-border hover:bg-muted"}`}>
                <span className="inline-block h-2 w-2 rounded-full mr-1.5" style={{ background: c }} />{l} <b>{n}</b>
              </button>
            );
          })}
        </div>
        <div className="max-h-[55vh] overflow-y-auto divide-y divide-border border border-border rounded" data-testid="ts-list">
          {shown.length === 0 && <p className="text-sm text-muted-foreground p-6 text-center">Nessun progetto in questa categoria.</p>}
          {shown.map((p) => (
            <button key={p.id} type="button" onClick={() => navigate(`/leads/${p.id}`)} data-testid={`ts-item-${p.id}`}
              className="w-full flex items-center justify-between gap-3 px-4 py-2.5 text-left hover:bg-secondary/50 transition-colors">
              <div className="min-w-0">
                <div className="font-semibold text-sm truncate">{p.name}</div>
                <div className="text-[11px] text-muted-foreground truncate">
                  {STAGE_LABELS[p.stage] || p.stage}{p.city ? ` · ${p.city}` : ""}{p.assigned_to_name ? ` · ${p.assigned_to_name}` : ""}{p.kwp ? ` · ${p.kwp} kWp` : ""}{eur(p.prezzo) ? ` · ${eur(p.prezzo)}` : ""}
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-[11px] rounded-full px-2 py-0.5 border" style={{ borderColor: lbl[p.status]?.c, color: lbl[p.status]?.c }}>{lbl[p.status]?.l}</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground" />
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
